import { render, staticRenderFns } from "./LabelContractsAdvanceEditPanel.vue?vue&type=template&id=050af9d2"
import script from "./LabelContractsAdvanceEditPanel.vue?vue&type=script&lang=js"
export * from "./LabelContractsAdvanceEditPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports